 
import { Employee } from "../types/employee";
import { createApiStore } from "./genericStore";
 
export const useEmployeeStore = createApiStore<Employee>("/employee");
